import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { LoginService } from '../services/login.service';

declare var require: any
const Swal = require('sweetalert2')

@Injectable({
  providedIn: "root",
})
export class termsAndConditionsGuard  {
  constructor(public router: Router, private toastr: ToastrService, private loginService: LoginService) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    // Guard for user is login or not
    let user = JSON.parse(localStorage.getItem('user')!);
    
    if (Number(user.user.fast_registration == 1 || !user.user.guardian.national_id)) {
      Swal.fire('يجب استكمال البيانات')
      this.router.navigate(["/complete-user-data"]);
      return true;
    }
    
    else if (Number(user.user.accept_terms_flag == 0)) {
      Swal.fire('يجب الموافقة علي الشروط و الأحكام')
      this.router.navigate(["/terms-and-conditions/from-login"]);
      return true;
    }

    return true;
  }
}
